export default "__VITE_ASSET__QpUyo6MS__"